import { NormalizedCacheObject } from '@apollo/client';
import { ApolloClient } from '@apollo/client';
import { loader } from 'graphql.macro';
import {
  FetchPipelineSummaryFiltersResponse,
  GetPipelineSummaryInput,
} from '../../pipeline-summary-types';

const query = loader('./get-pipeline-summary-filters.gql');

const fetchPipelineSummaryFilters = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return {
    execute: async (
      getApplicationsSbom: GetPipelineSummaryInput,
      cache: boolean = true,
    ) => {
      const results = await client.query<FetchPipelineSummaryFiltersResponse>({
        query,
        variables: { getApplicationsSbom },
      });
      if (!results.data) return null;
      return results.data.getPipelineSummaryFilters;
    },
  };
};

export default fetchPipelineSummaryFilters;
